import { useIsFlagEnabled } from "@shared/features/Flags";

export function useUploadComponents() {
    return !useIsFlagEnabled("disable uploadComponents");
}
